import React from "react";
import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";

interface GuestTypeBadgeProps {
  guestType: "adult" | "child" | "infant";
  size?: "small" | "medium";
  sx?: object;
}

export const GuestTypeBadge: React.FC<GuestTypeBadgeProps> = ({
  guestType,
  size = "small",
  sx = {},
}) => {
  const { t } = useTranslation();

  const colors = {
    adult: { color: "#1976d2", backgroundColor: "#e3f2fd" },
    child: { color: "#388e3c", backgroundColor: "#e8f5e8" },
    infant: { color: "#f57c00", backgroundColor: "#fff3e0" },
  };

  return (
    <Chip
      label={t(`guestType.${guestType}`)}
      size={size}
      sx={{
        ...colors[guestType],
        fontWeight: 500,
        fontSize: "0.75rem",
        ...sx,
      }}
    />
  );
};
